"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MovingAverageIndication = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
const moving_average_indicator_enum_1 = require("../../@types/incoming/enum/moving-average-indicator.enum");
const specific_investor_mm_enum_1 = require("../../@types/outcoming/enum/specific-investor-mm.enum");
class MovingAverageIndication {
    constructor(investorType) {
        this.investorType = investorType;
    }
    getIndication(indicators) {
        const advancedIndicators = this.getAdvancedIndicators(indicators);
        const advancedIndSummary = this.getAdvancedIndSummary(advancedIndicators);
        const specificIndByInvestor = this.getIndicationByInvestor(indicators);
        const points = this.getInternalPoints(specificIndByInvestor.periods);
        return {
            advanced: advancedIndicators,
            specificInvestorType: specificIndByInvestor,
            summary: advancedIndSummary,
            internalPoints: points,
        };
    }
    getAdvancedIndSummary(indications) {
        let qntNeutral = 0;
        let qntBuy = 0;
        let qntSell = 0;
        indications.forEach((indication) => {
            switch (indication.value) {
                case moving_average_indicator_enum_1.eMovingAverageIndicator.NEUTRAL:
                    return qntNeutral++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.BUY:
                    return qntBuy++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.SELL:
                    return qntSell++;
            }
        });
        return {
            qntBuy,
            qntSell,
            qntNeutral,
        };
    }
    getPeriodIndication(periodIndicators) {
        let qntNeutral = 0;
        let qntBuy = 0;
        let qntSell = 0;
        periodIndicators.forEach((indicator) => {
            switch (indicator) {
                case moving_average_indicator_enum_1.eMovingAverageIndicator.NEUTRAL:
                    return qntNeutral++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.BUY:
                    return qntBuy++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.SELL:
                    return qntSell++;
            }
        });
        if (qntBuy > qntSell && qntBuy > qntNeutral) {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.BUY;
        }
        else if (qntSell > qntBuy && qntSell > qntNeutral) {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.SELL;
        }
        else {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.NEUTRAL;
        }
    }
    getIndicationByInvestor(indicators) {
        const shortsPeriods = this.getShortPeriodIndicators(indicators);
        const midPeriods = this.getMidPeriodIndicators(indicators);
        const longPeriods = this.getLongPeriodIndicators(indicators);
        switch (this.investorType) {
            case investor_type_enum_1.eInvestorType.DAY_TRADER:
                return {
                    name: 'Médias Móveis - Day Trader.',
                    value: this.getPeriodIndication(shortsPeriods),
                    periods: [
                        {
                            name: 'MA 5 Périodos',
                            value: indicators.MA5_SIM,
                        },
                        {
                            name: 'EMA 5 Périodos',
                            value: indicators.MA5_EXP,
                        },
                        {
                            name: 'MA 10 Périodos',
                            value: indicators.MA10_SIM,
                        },
                        {
                            name: 'EMA 10 Périodos',
                            value: indicators.MA10_EXP,
                        },
                    ],
                };
            case investor_type_enum_1.eInvestorType.SWING_TRADER:
                return {
                    name: 'Médias Móveis - Swing Trader',
                    value: this.getPeriodIndication(midPeriods),
                    periods: [
                        {
                            name: 'MA 20 Périodos',
                            value: indicators.MA20_SIM,
                        },
                        {
                            name: 'EMA 20 Périodos',
                            value: indicators.MA20_EXP,
                        },
                        {
                            name: 'MA 50 Périodos',
                            value: indicators.MA50_SIM,
                        },
                        {
                            name: 'EMA 50 Périodos',
                            value: indicators.MA50_EXP,
                        },
                    ],
                };
            case investor_type_enum_1.eInvestorType.BUY_AND_HOLDER:
                return {
                    name: 'Médias Móveis - Conservative Trader',
                    value: this.getPeriodIndication(longPeriods),
                    periods: [
                        {
                            name: 'MA 100 Périodos',
                            value: indicators.MA100_SIM,
                        },
                        {
                            name: 'EMA 100 Périodos',
                            value: indicators.MA100_EXP,
                        },
                        {
                            name: 'MA 200 Périodos',
                            value: indicators.MA200_SIM,
                        },
                        {
                            name: 'EMA 200 Périodos',
                            value: indicators.MA200_EXP,
                        },
                    ],
                };
        }
    }
    getAdvancedIndicators(indicators) {
        return [
            { id: 0, name: 'MA10', value: indicators.MA5_SIM },
            { id: 1, name: 'EMA10', value: indicators.MA10_EXP },
            { id: 2, name: 'MA20', value: indicators.MA20_SIM },
            { id: 3, name: 'EMA20', value: indicators.MA20_EXP },
            { id: 4, name: 'MA50', value: indicators.MA50_SIM },
            { id: 5, name: 'EMA50', value: indicators.MA50_EXP },
            { id: 6, name: 'MA100', value: indicators.MA100_SIM },
            { id: 7, name: 'EMA100', value: indicators.MA100_EXP },
            { id: 8, name: 'MA200', value: indicators.MA200_SIM },
            { id: 9, name: 'EMA200', value: indicators.MA200_EXP },
        ];
    }
    getInternalPoints(periods) {
        let qntPoints = 0;
        periods.forEach((period) => {
            switch (period.value) {
                case moving_average_indicator_enum_1.eMovingAverageIndicator.BUY:
                    return qntPoints++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.SELL:
                    return qntPoints--;
            }
        });
        return qntPoints;
    }
    getShortPeriodIndicators(indicators) {
        return [
            indicators.MA5_EXP,
            indicators.MA5_SIM,
            indicators.MA10_EXP,
            indicators.MA10_SIM,
        ];
    }
    getMidPeriodIndicators(indicators) {
        return [
            indicators.MA20_EXP,
            indicators.MA20_SIM,
            indicators.MA50_EXP,
            indicators.MA50_SIM,
        ];
    }
    getLongPeriodIndicators(indicators) {
        return [
            indicators.MA100_EXP,
            indicators.MA100_SIM,
            indicators.MA200_EXP,
            indicators.MA200_SIM,
        ];
    }
}
exports.MovingAverageIndication = MovingAverageIndication;
//# sourceMappingURL=moving-average.indication.js.map